export default __webpack_public_path__ + "static/media/body-temp-icon.67ae2501.svg";